module.exports = __webpack_public_path__ + "d840c7229af1d7952c5c0c779024f174.svg";